import { getActiveFaro } from "../setup/initialize.js";
/** Attaches the signed-in user's id (never email or name) to all following signals. */
export function setFaroUser(userId) {
    getActiveFaro()?.api.setUser({ id: userId });
}
export function resetFaroUser() {
    getActiveFaro()?.api.resetUser();
}
//# sourceMappingURL=user.js.map